const style = {
  h3: {
    marginTop: 0,
    fontSize: 20,
    marginBottom: 24,
  },
  error: {
    fontSize: 12,
    color: '#FF0000',
    marginBottom: 1,
    marginTop: 10,
    '&.text-center': {
      textAlign: 'center',
      marginTop: '0',
    },
  },
  spacing: {
    marginBottom: 24,
    '& .MuiCardContent-root': {
      padding: 24,
    },
  },
  editButtonWrap: {
    textAlign: 'right',
    '& button': {
      background: 'transparent',
      border: 'none',
      '& svg': {
        width: 18,
        height: 18,
        fill: '#011533',
      },
    },
  },
  checkbox: {
    display: 'flex',
    height: 'auto',
    width: 'calc(100% - 23px)',
    '& label': {
      wordWrap: 'break-word',
    },
    '& .checkbox-wrapper': {
      flexShrink: 0,
    },
  },
  chip: {
    backgroundColor: '#E0F5E2',
    color: '#00840D',
    height: 20,
    fontSize: 12,
    borderRadius: 8,
    '& .MuiChip-label': {
      paddingLeft: 10,
      paddingRight: 10,
      width: '100%',
    },
  },
  deleteButton: {
    background: 'transparent',
    border: 'none',
    padding: 0,
    color: '#707087',
    height: 20,
    display: 'block',
  },
  optionsList: {
    marginTop: 10,
    marginBottom: 0,
    paddingLeft: 0,
    columns: 2,
    '& li': {
      listStyle: 'none',
      position: 'relative',
      paddingLeft: 16,
      wordWrap: 'break-word',
      '&:before': {
        content: '""',
        backgroundColor: '#004360',
        width: 8,
        height: 8,
        borderRadius: 8,
        position: 'absolute',
        top: 5,
        left: 0,
      },
    },
  },
}
export default style
